import { Typography, useMediaQuery, useTheme } from "@mui/material";
import "@/components/styles/headerBar.css";
import { useTranslation } from "react-i18next";

interface Props {
  companyLogo?: any;
  companyName?: string;
}

export default function CompanyArea(props: Props) {
  const { t } = useTranslation();

  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0];

  const portalNames: Record<string, string> = {
    admin: t("kaer_staff_portal_name"),
    manage: t("kaer_manager_portal_name"),
    portal: t("kaer_employee_portal_name"),
  };

  const portalName = portalNames[subdomain] || subdomain;

  const renderCompanyName = (
    <Typography variant="h5" className="companyNameTruncate">
      {props.companyName}
    </Typography>
  );

  const renderPortalName = (
    <span className="portalNameWrapper">
      ({portalName})
    </span>
  );

  return (
    <div className="companyAreaWrapper">
      {renderCompanyName}
      {isTablet && renderPortalName}
    </div>
  );
}
